<template>
	<transition name="scroll-y-reverse-transition" v-if="module">
		<v-row v-show="module" class="module mb-12" align="center" v-bind:class="{ 'swap-image-position': module.swapImagePosition }">
			<v-col
				:cols="$vuetify.breakpoint.xsOnly ? 12 : $vuetify.breakpoint.mdAndUp ? 5 : 6"
				:order="$vuetify.breakpoint.xsOnly || module.swapImagePosition ? 1 : 0"
				class="module__text white pa-8 module__first-column"
			>
				<div class="module__tag px-6 accent d-inline-flex mb-2" v-if="module.tagTitle && hasImages">
					<h3 class="font--text">{{ module.tagTitle }}</h3>
				</div>
				<h2 class="display-1 mb-2">{{ module.title }}</h2>
				<p class="mb-9">{{ module.text }}</p>
				<template v-for="link in module.link">
					<v-btn :key="link.Caption" outlined :href="link.link" :target="link.OpenInNewWindow ? '_blank' : '_self'">{{ link.caption }}</v-btn>
				</template>
			</v-col>

			<v-col
				:cols="$vuetify.breakpoint.xsOnly ? 12 : $vuetify.breakpoint.mdAndUp ? 7 : 6"
				:order="$vuetify.breakpoint.xsOnly || module.swapImagePosition ? 0 : 1"
				style="position: relative;"
				v-bind:class="{ white: $vuetify.breakpoint.xsOnly }"
			>
				<div class="module__images">
					<v-img
						v-if="module.images.topImage"
						:aspect-ratio="1000 / 600"
						:src="imageSrc(module.images.topImage)"
						:alt="module.images.topImageAltText"
						lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg=="
						@load="imgIsLoaded = true"
					/>
				</div>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
export default {
	name: 'text-and-image-module',
	props: ['module'],
	data() {
		return {
			imgIsLoaded: false
		};
	},
	methods: {
		imageSrc(test) {
			if (!test.imageCrops) {
				return '';
			}
			return test.imageCrops.find(ic => ic.alias == 'Teaser Image').cropUrl;
		}
	},
	computed: {
		hasImages() {
			return !!(Object(this.module).images && (this.module.images.topImage || this.module.images.middleImage || this.module.images.bottomImage));
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.module {
	&__first-column {
		// Desktop rules
		@media #{map-get($display-breakpoints, 'sm-and-up')} {
			position: relative;
			right: -60px;
			z-index: 1;
		}
	}
	&.swap-image-position {
		.module__first-column {
			// Desktop rules
			@media #{map-get($display-breakpoints, 'sm-and-up')} {
				position: relative;
				right: 60px;
				z-index: 1;
			}
		}
	}

	&__text {
		h2 {
			font-size: 2rem;
			max-width: 20ch;
			line-height: 1.25;
		}

		p {
			max-width: 40ch;
		}
	}

	&__images {
		display: grid;

		/* Mobile */
		@media #{map-get($display-breakpoints, 'xs-only')} {
			grid-template-columns: 1fr 1fr;
			grid-template-rows: 1fr 4fr 1fr;

			& > *:first-child {
				grid-row: 1 / 3;
			}

			& > *:nth-child(2) {
				grid-row: 2 / 4;
			}

			& > *:nth-child(3) {
				display: none;
			}

			& > *:only-child {
				grid-column: 1 / 3;
				grid-row: 1 / 4;
			}
		}

		/* Desktop & Tablet */
		@media #{map-get($display-breakpoints, 'sm-and-up')} {
			grid-template-columns: 1fr;

			& > *:first-child {
				grid-column: 1;
			}
		}
	}
}
</style>
